export const ACTIVITY_REVIEW_HEADING_TEXT = "Review activity";
export const ACTIVITY_REVIEW_SUBTITLE_TEXT =
  "Review your activity before you confirm and book.";

export const CONFIRMATION_EMAIL_HEADING = "Confirmation email";
export const VOUCHER_EMAIL_NOTICE =
  "Your confirmation and voucher will be sent to the email associated with your Capital One Travel account.";
